/* eslint-disable */
import React, { Fragment, useRef, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CompanyLogo from "../../../../assets/images/ck_logo_new.png";
import {
  Button,
  CircularProgress,
  Grid,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import ReactToPrint from "react-to-print";
import { useParams } from "react-router-dom";
import { HttpRequest } from "../../../../utils/httpRequests";
import CustomizedSnackbar from "../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import Barcode from "react-barcode";
import format from "date-fns/format";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import { Tooltip, IconButton } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { MenuItem } from "@material-ui/core";
import { G } from "@react-pdf/renderer";

const useStyles = makeStyles(() => ({
  page: {
    padding: 5,
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  barcodeContainer: {
    display: "flex",
    flexDirection: "column",
  },
  barcodeText: {
    textAlign: "center",
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginLeft: 100,
  },
  subTitle: {
    marginTop: 20,
  },
  tableContainer: {
    marginTop: 10,
  },
  table: {
    fontFamily: "arial, sans-serif",
    borderCollapse: "collapse",
    width: "100%",
  },
  table2: {
    fontFamily: "arial, sans-serif",
    borderCollapse: "collapse",
    width: "100%",
  },
  table2Content: {
    border: "1px solid #000000",
    textAlign: "center",
    padding: 2,
    width: "50%",
  },
  tableContent: {
    borderStyle: "none",
    textAlign: "center",
    justifyContent: "center",
    padding: 2,
    width: "50%",
  },
  tableMainLeftContent: {
    borderStyle: "none",
    textAlign: "left",
    justifyContent: "left",
    padding: 2,
    width: "50%",
  },
  tableMainRightContent: {
    borderStyle: "none",
    textAlign: "right",
    justifyContent: "right",
    padding: 2,
    width: "50%",
  },
  tableSenderRecieverTitle: {
    borderStyle: "none",
    textAlign: "left",
    justifyContent: "left",
    padding: 2,
    width: "50%",
  },
  tableSenderRecieverContentKey: {
    border: "1px solid #000000",
    textAlign: "left",
    justifyContent: "left",
    padding: 2,
    width: "20%",
  },
  tableSenderRecieverContent: {
    border: "1px solid #000000",
    textAlign: "left",
    justifyContent: "left",
    padding: 2,
    width: "80%",
  },
  tableBarCodeContent: {
    border: "1px solid #000000",
    textAlign: "center",
    padding: 2,
  },

  imageContent: {
    objectFit: "contain",
    maxHeight: "100px",
    maxWidth: "50%",
  },
  footerContainer: {
    display: "flex",
    float: "right",
    marginTop: 70,
  },
  loadingContainer: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  loader: {
    marginTop: "20%",
  },
  userDetails: {
    display: "flex",
    justifyContent: "space-around",
    width: "100%",
  },
  userDetailsTitle: {
    borderRight: "1px solid #000000",
    width: "50%",
    padding: "3px",
  },
  userDetailsData: {
    width: "50%",
    wordBreak: "break-word",
    justifyContent: "center",
    textAlign: "center",
    padding: "3px",
  },
}));

const DispatchShippingLabelPrintViewV3 = (props) => {
  const classes = useStyles();
  const componentRef = useRef();

  //   let { orderId } = useParams();
  const { handleClose, open, state, onHandleChange, onSaveClick } = props;

  const [dispatchShippingLabelData, setDispatchShippingLabelData] = useState(
    []
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenSnackbar, setIsOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("");

  const [userName, setUserName] = useState("");
  const [dateTime, setDateTime] = useState("");

  const handleSnackbar = (isOpen, message, severity) => {
    setIsOpenSnackbar(isOpen);
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
  };

  const [deliveryId, setDeliveryId] = useState("");
  const handleDeliveryId = (deliveryId) => {
    setDeliveryId(deliveryId);
  };

  const [deliveryPersonAccountId, setDeliveryPersonAccountId] = useState("");
  const handleDeliveryPersonAccountId = (deliveryPersonAccountId) => {
    setDeliveryPersonAccountId(deliveryPersonAccountId);
  };

  const handleWeightChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d+(\.\d{0,2})?$/.test(value)) {
      onHandleChange(e);
    }
  };

  const handleChargesChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d+$/.test(value)) {
      onHandleChange(e);
    }
  };

  console.log(state.selectedOrder);

  return (
    <Fragment>
      <ControlledDialog
        open={props.open}
        disableBackdropClick
        handleClose={(actionTypeId) => props.handleClose(0)}
        title={
          <Fragment>
            <Tooltip title="Back">
              <IconButton onClick={(actionTypeId) => props.handleClose(0)}>
                <ArrowBackIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >{`Order # ${state.selectedOrder.orderId} - Select Delivery Partner`}</span>
          </Fragment>
        }
        content={
          <Fragment>
            <Grid spacing={2} container xs={12}>
              <Grid item xs={6}>
                <b>To Name: </b> {state.selectedOrder.senderName}
              </Grid>
              <Grid item xs={6}>
                <b>Contact No: </b> {state.selectedOrder.contactNo}
              </Grid>
              <Grid item xs={12}>
                <b>Address: </b> {state.selectedOrder.completeAddress}
              </Grid>
              <Grid item xs={12}>
                <div></div>
              </Grid>
              <Grid item xs={6}>
                {/* <span className={classes.label}>Delivery Partner</span> */}
                <TextField
                  label="Delivery Partner"
                  variant="outlined"
                  fullWidth
                  name="deliveryPartner"
                  disabled={state.isDeliveryPartnerAttached == 1}
                  error={!!state.deliveryPartnerError}
                  helperText={state.deliveryPartnerError}
                  value={state.deliveryPartner}
                  onChange={(e) => {
                    onHandleChange(e);
                    handleDeliveryId(e.target.value);
                  }}
                  // onChange={onHandleChange}
                  InputProps={{ classes: { input: classes.resize } }}
                  select
                  size="small"
                >
                  {state.deliveryPartnerData.map((item) => {
                    return (
                      <MenuItem key={item.id} value={item.id}>
                        {item.label}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              {state.isDeliveryPartnerAttached == 1 && (
                <>
                  <Grid item xs={2}>
                    <Button
                      // onClick={() =>
                      //   onSaveClick(state.actionTypeId, state.orderItemId)
                      // }

                      variant="contained"
                      color="primary"
                      disabled={!!state.deliveryPartnerError}
                      onClick={(actionTypeId) => handleClose(2)}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </>)
              }


              <Grid item xs={4}>
                {/* <span className={classes.label}>Weight In Kg's</span> */}
                <TextField
                  fullWidth
                  id="weight"
                  name="orderWeightInKg"
                  label="Weight In Kg's"
                  disabled={state.isDeliveryPartnerAttached == 1}
                  value={state.orderWeightInKg || ""}
                  type="text"
                  variant={"outlined"}
                  onChange={handleWeightChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{ inputMode: 'decimal' }}
                  size="small"
                />
              </Grid>
              {state.deliveryPartner == 3 && (
                <>
                  <Grid item xs={6}>
                    {/* <span className={classes.label}>Self Delivery Charges</span> */}
                    <TextField
                      label=" Delivery Person"
                      variant="outlined"
                      fullWidth
                      name="deliveryPersons"
                      disabled={state.isDeliveryPartnerAttached == 1}
                      error={!!state.deliveryPersonsError}
                      helperText={state.deliveryPersonsError}
                      value={state.deliveryPersons}
                      onChange={(e) => {
                        onHandleChange(e);
                        handleDeliveryPersonAccountId(e.target.value);
                      }}
                      // onChange={onHandleChange}
                      InputProps={{ classes: { input: classes.resize } }}
                      select
                      size="small"
                    >
                      {state.deliveryPersonsData.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.label}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                  <Grid item xs={4}>
                    {/* <span className={classes.label}>Self Delivery Charges</span> */}
                    <TextField
                      fullWidth
                      id="selfDeliveryCharges"
                      name="selfDeliveryCharges"
                      label="Self Delivery Charges"
                      disabled={state.isDeliveryPartnerAttached == 1}
                      value={state.selfDeliveryCharges || ""}
                      type="text"
                      variant={"outlined"}
                      onChange={handleChargesChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ inputMode: 'numeric' }}
                      size="small"
                    />
                  </Grid>

                </>
              )}
            </Grid>
            <div
              style={{ marginTop: 20, float: "right" }}
              className={classes.actions}
            >
              <Button
                // onClick={() =>
                //   onSaveClick(state.actionTypeId, state.orderItemId)
                // }
                // disabled={state.onCancelItemStatusLoading}
                variant="contained"
                color="primary"
                disabled={!!state.deliveryPartnerError}
                onClick={(actionTypeId) => handleClose(1)}
              >
                {state.isDeliveryPartnerAttached == 1 ? "View" : "Yes"}
              </Button>
              {state.isDeliveryPartnerAttached != 1 && (
                <Button
                  // disabled={state.onCancelItemStatusLoading}
                  style={{ marginLeft: 20 }}
                  onClick={(actionTypeId) => handleClose(0)}
                  variant="contained"
                >
                  No
                </Button>
              )}
            </div>
          </Fragment>
        }
      />
      <CustomizedSnackbar
        isOpen={isOpenSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity}
        handleCloseSnackbar={() => handleSnackbar(false, "", "")}
        autoHideDuration={3000}
      />
    </Fragment>
  );
};

export default DispatchShippingLabelPrintViewV3;
